module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/eb30e4c6c960fa1c576a447b0a8b3da1.png";